"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:7.2.0'] && _();
}
catch (e) { }
